import { getCurrentUser } from 'api/users.api';
import { $detail, $filter, $form, $list, $user, $view } from 'signals/global.signals';
import { signOut } from 'utils/auth';
import displayError from 'utils/displayError';
import { auth } from 'utils/firebase';

export const handleShowModal = (modalName, data = null) => {
  $form.reset();
  $view.update({
    activeModal: modalName,
  });
  if (data) {
    $form.update(data);
  }
};

export const handleHideModal = () => {
  $view.update({
    activeModal: null,
  });
  $form.reset();
};

export const handleInputChange = ({ name, value }) => {
  $form.update({
    [name]: value,
  });
};

export const handleSignout = async () => {
  await signOut();
  window.location.href = '/';
};

export const handleRefreshDbUser = async ({ isSoft = false } = {}) => {
  if (!isSoft) {
    $user.update({ isLoading: true });
  }
  try {
    const user = await getCurrentUser();

    if (!user) {
      await signOut(auth);
      throw new Error('User not found in database');
    }

    if (user.archived) {
      // Show helpful message but don't block completely
      displayError({
        message: 'Your account is archived. You can reactivate it by signing up again with the same email address.',
        title: 'Account Archived',
      });
      // Still set the user data so they can see the message and navigate to signup
      $user.update({
        ...user,
        accountStatus: 'archived',
        userType: user?.userType?.description?.toLowerCase(),
      });
      return;
    }

    if (user) {
      $user.update({
        ...user,
        accountStatus: 'active',
        userType: user?.userType?.description?.toLowerCase(),
      });
    }
  } catch (error) {
    console.error('error', error);
    if (error.message === 'User account is archived') {
      displayError({
        message: 'Your account is archived. You can reactivate it by signing up again with the same email address.',
        title: 'Account Archived',
      });
    } else {
      displayError({
        message: 'Failed to refresh user data. Please try logging in again.',
        title: 'User Refresh Error',
      });
    }
  } finally {
    $user.update({ isLoading: false });
  }
};

export const getRatingColor = (rating) => {
  if (!rating) return 'secondary';
  if (rating.includes('A')) return 'success';
  if (rating.includes('B')) return 'primary';
  if (rating.includes('C')) return 'warning';
  if (rating.includes('D') || rating.includes('F')) return 'danger';
  return 'secondary';
};

export const handleCleanUpCommonSignals = () => {
  $view.reset();
  $form.reset();
  $list.reset();
  $detail.reset();
  $filter.reset();
};

export const handleFilterChange = ({ name, value }) => {
  $filter.update({
    [name]: value,
  });
};
